<app-icon-refresh
	[ngClass]="{ disabled: isDisabled }"
	(click)="onUndoClick()"
	[iconCls]="'icon--light'"
></app-icon-refresh>
